import { Route } from 'react-router';
import DrawRequest from '../drawRequests/drawRequest';
import ViewDraws from '../viewDraws/viewDraws';
import { Page } from '@roc/feature-app-core';

export const getDrawsRoutesConfig = (
  basePath: string,
  baseUrl: string
) => {
  return {
    draws: {
      path: `${basePath}/draws`,
      url: `${baseUrl}/draws`,
      documentTitle: 'View Draws',
    },
  };
};

export const getDrawsRoutes = (basePath: string, baseUrl: string) => {
  const config = getDrawsRoutesConfig(basePath, baseUrl);

  return {
    draws: (
      <Route exact path={config.draws.path}>
        <Page routeDefinition={config.draws}>
          <ViewDraws />
        </Page>
      </Route>
    ),
  };
};
